import { viewportProjection } from '../viewportProjection.js';
import VideoViewport from './VideoViewport.js';
class VideoViewportLegacyAdapter extends VideoViewport {
    setDataIds(imageIds, options) {
        const dataId = imageIds[0];
        if (!dataId) {
            return;
        }
        return this.setVideo(dataId, (options?.viewReference?.sliceIndex || 0) + 1);
    }
    async setVideo(imageId, frameNumber) {
        await this.setDisplaySets({ displaySetId: imageId });
        if (typeof frameNumber === 'number') {
            this.setFrameNumber(frameNumber);
        }
        return this;
    }
    setProperties(props) {
        const dataId = this.getFirstBinding()?.data.id;
        if (!dataId) {
            return;
        }
        const dataPresentation = {};
        const viewPresentation = {};
        if (typeof props.loop === 'boolean') {
            dataPresentation.loop = props.loop;
        }
        if (typeof props.muted === 'boolean') {
            dataPresentation.muted = props.muted;
        }
        if (typeof props.playbackRate === 'number') {
            dataPresentation.playbackRate = props.playbackRate;
        }
        if (props.pan) {
            viewPresentation.pan = props.pan;
        }
        if (props.voiRange) {
            dataPresentation.voiRange = props.voiRange;
        }
        if (props.invert !== undefined) {
            dataPresentation.invert = props.invert;
        }
        if (Object.keys(dataPresentation).length) {
            this.setDisplaySetPresentation(dataId, dataPresentation);
        }
        if (Object.keys(viewPresentation).length) {
            this.setViewPresentation(viewPresentation);
        }
    }
    getViewPresentation(selector) {
        return viewportProjection.getPresentation(this, {
            selector,
        });
    }
    setViewPresentation(viewPres) {
        if (!viewPres) {
            return;
        }
        const nextViewState = viewportProjection.withPresentation(this, viewPres);
        if (nextViewState) {
            this.setViewState(nextViewState);
        }
    }
    resetCamera() {
        return this.resetViewState();
    }
    getProperties() {
        const dataId = this.getFirstBinding()?.data.id;
        const dataPresentation = dataId
            ? this.getDisplaySetPresentation(dataId)
            : undefined;
        const viewPresentation = this.getViewPresentation();
        return {
            invert: dataPresentation?.invert,
            loop: dataPresentation?.loop,
            muted: dataPresentation?.muted,
            pan: viewPresentation?.pan,
            playbackRate: dataPresentation?.playbackRate,
            voiRange: dataPresentation?.voiRange,
        };
    }
    resetProperties() {
        const dataId = this.getFirstBinding()?.data.id;
        if (!dataId) {
            return;
        }
        this.setDisplaySetPresentation(dataId, {
            invert: false,
            loop: true,
            muted: true,
            playbackRate: 1,
            voiRange: undefined,
        });
        this.setViewPresentation({
            pan: [0, 0],
            zoom: 1,
        });
    }
    setVOI(voiRange) {
        const dataId = this.getFirstBinding()?.data.id;
        if (!dataId) {
            return;
        }
        this.setDisplaySetPresentation(dataId, { voiRange });
    }
    setAverageWhite(averageWhite) {
        const dataId = this.getFirstBinding()?.data.id;
        if (!dataId) {
            return;
        }
        this.setDisplaySetPresentation(dataId, { averageWhite });
    }
}
export default VideoViewportLegacyAdapter;
